/* ON AIR and OFF AIR.
 *
 * The same rectangle, the same size, in the same position. That is the whole
 * point: a badge that only exists when the station is live teaches a visitor
 * nothing about the state they are actually in most of the week, and a badge
 * that changes size makes the layout jump on a poll response.
 *
 * The WORD carries the meaning. The strike rule through OFF AIR carries it a
 * second time. Colour only amplifies — cover the screen in greyscale and both
 * states are still unambiguous, which is the test this component exists to
 * pass.
 *
 * The blink is a hard steps(1) snap at 1.6s, a transmitter lamp rather than a
 * notification breathing, and base.css freezes it at the LIT frame under
 * prefers-reduced-motion — off is not a state we want to leave someone in.
 */

export interface OnAirBadgeProps {
  live: boolean;
  /** Overrides the word. Only for a surface where "LIVE" is the house term. */
  label?: string;
  /** `sm` is the 96px version used inside a schedule row. */
  size?: 'sm' | 'md';
  className?: string;
}

export function OnAirBadge({ live, label, size = 'md', className }: OnAirBadgeProps) {
  const word = label ?? (live ? 'ON AIR' : 'OFF AIR');
  const classes = [live ? 'onair' : 'offair', size === 'sm' ? 'onair--sm' : null, className]
    .filter(Boolean)
    .join(' ');

  return (
    /* The live region is the WRAPPER, not the badge. It has to survive the
       state change for a screen reader to notice one happened; the badge
       inside it swaps class, word and rule. */
    <span className="onair-slot" aria-live="polite">
      <span className={classes}>{word}</span>
    </span>
  );
}
